export default "__VITE_ASSET__DOST12w___"